import { getArticleList, getArticle, getTotalArticles, delArticle } from "../repositories/dataRetrieve";
import { AddArticle, AddPhysicalState, SnackBarMessage } from "../components/index";
import { Add, Category, Delete, Edit, Outbox } from "@mui/icons-material";
import { currencyFormat, formatCifra } from "../repositories/utils";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { CircularProgress,
        TableContainer,
        Typography,
        IconButton,
        TableHead,
        TableBody,
        TableCell,
        TableRow,
        Backdrop,
        Divider,
        Button,
        Table,
        Paper,
        Stack,
        Chip,
        Box } from '@mui/material';

const CommonAdminListPage = () => {
    const navigate = useNavigate();
	const [showPhysicalCanvas, setShowPhysicalCanvas] = useState(false);
	const [showArticleCanvas, setShowArticleCanvas] = useState(false);
    const [snackSeverity, setSnackSeverity] = useState("success");
	const [selectedArticle, setSelectedArticle] = useState([]);
    const [totalInvestment, setTotalInvestment] = useState(0);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [totalProducts, setTotalProducts] = useState(0);
    const [snackMessage, setSnackMessage] = useState("");
    const [productList, setProductList] = useState([]);
    const [snackOpen, setSnackOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCloseArticleCanvas = () => {
		setSelectedArticle([]);
		setShowArticleCanvas(false);
        getProducts();
        getTotals();
	};

    const handleClosePhysicalCanvas = () => {
		setShowPhysicalCanvas(false);
	};

    const handleCategories = () => {
		setShowPhysicalCanvas(true);
    };

    const handleArticles = async (pk) => {
		if (pk !== null) {
			const rowData = await getArticle(pk);
			setSelectedArticle(rowData?.data);
		}
		setShowArticleCanvas(true);
    };

    const handleDeleteArticle = async (pk) => {
        setLoadingDelete(true);
        const resp = await delArticle(pk);

        if (resp?.message?.toUpperCase() === "OK") {
            setSnackSeverity("success");
            setSnackMessage("Se eliminó el artículo con éxito.");
            setSnackOpen(true);
            getProducts();
            getTotals();
            setLoadingDelete(false);
        } else {
            setSnackSeverity("error");
            setSnackMessage(`Error en la eliminación del artículo seleccionado.`);
            setSnackOpen(true);
            getProducts();
            getTotals();
            setLoadingDelete(false);
        };
    };

    const getProducts = async () => {
        setIsLoading(true);
        const resp = await getArticleList();

        if (resp?.message?.toUpperCase() === "OK") {
            setProductList(resp?.data);
            setIsLoading(false);
        } else {
            setProductList([]);
            setIsLoading(false);
        };
    };

    const getTotals = async () => {
        const resp = await getTotalArticles();

        if (resp?.message?.toUpperCase() === "OK") {
            setTotalProducts(resp?.data?.totalProducts);
            setTotalInvestment(resp?.data?.totalInvestment);
        } else {
            setTotalProducts(0);
            setTotalInvestment(0);
        };
    };

    useEffect(() => {
        getProducts();
        getTotals();
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(217, 217, 217, 0.5)',
                margin: 'auto',
                marginTop: {xs: '2vh', md:'5vh'},
                marginBottom: {xs: '2vh', md:'5vh'},
                height: {xs: '85vh', md:'80vh'},
                width: {xs: '90vw', md:'75vw'},
                borderRadius: '20px',
                overflowY: 'auto'
            }}
        >
            {/* Comportamiento pc */}
            <Box sx={{ display: { xs: 'none', md: "flex" } }}>
                <Typography
                    width='60%'
                    variant="h3"
                    component="div"
                    sx={{
                        justifyContent: 'left',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        margin: '1rem'
                    }}
                >
                    Artículos registrados
                </Typography>

                <Stack
                    width='40%'
                    direction="row"
                    spacing={1}
                    justifyContent='end'
                    marginRight='2rem'
                    sx={{
                        maxHeight: '2rem',
                        display: 'flex',
                        alignSelf: 'center'
                    }}
                >
                    <Button variant="contained" size="small" color="warning" startIcon={<Category />} onClick={() => handleCategories()}>
                        Categorias
                    </Button>
                    <Button variant="contained" size="small" color="info" startIcon={<Add />} onClick={() => handleArticles()}>
                        Registrar
                    </Button>
                </Stack>
            </Box>

            {/* Comportamiento moviles */}
            <Box sx={{ display: { xs: 'flex', md: "none" } }}>
                <Typography
                    width='85%'
                    variant="h5"
                    component="div"
                    sx={{
                        justifyContent: 'left',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        margin: '1rem'
                    }}
                >
                    Artículos registrados
                </Typography>

                <Stack
                    width='15%'
                    direction="row"
                    spacing={1}
                    justifyContent='end'
                    marginRight='1rem'
                    sx={{
                        maxHeight: '2rem',
                        display: 'flex',
                        alignSelf: 'center'
                    }}
                >
                    <IconButton aria-label="category" size="small" onClick={() => handleCategories()} >
                        <Category fontSize="inherit" color="warning" />
                    </IconButton>
                    <IconButton aria-label="add" size="small" onClick={() => handleArticles()} >
                        <Add fontSize="inherit" color="info" />
                    </IconButton>
                </Stack>
            </Box>

            <Divider sx={{ border: '1px #000 solid', width: '90%', justifySelf: 'center', marginBottom: { xs: "2rem", md: "3rem"} }} />

            {isLoading ?
                <Typography
                    variant="h2"
                    component="div"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        height: '70vh',
                        placeItems: 'center'
                    }}
                >
                    <CircularProgress sx={{ width: "70px !important", height: "70px !important", color: "#62C21B" }} />
                </Typography>
            :
                <>
                    {productList.length > 0 ?
                        <Box
                            sx={{
                                width: {xs: '90%', md: '96%'},
                                margin: {xs: '5%', md: '2%'},
                                rowGap: 2,
                                gap: 2,
                            }}
                        >
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: { xs: '70vh', md: "60vh" } }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <caption>Total de productos: {formatCifra(totalProducts)} <br/>Total invertido: {currencyFormat.format(parseFloat(totalInvestment))}</caption>
                                        <TableHead>
                                            <TableRow key="head-titles">
                                                <TableCell align="center">#</TableCell>
                                                <TableCell align="center">Descripción</TableCell>
                                                <TableCell align="center">Estatus</TableCell>
                                                <TableCell align="center">Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {productList.map((row, index) => (
                                                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell component="th" scope="row" align="center"> {index + 1} </TableCell>
                                                    <TableCell align="left"> {row.descripcion_corta} </TableCell>
                                                    <TableCell align="center">
                                                        {row.estatus === 'en_venta' ?
                                                            <Chip sx={{ color: 'white', fontWeight: 500 }} color="warning" label="En venta" />
                                                        :
                                                            <>
                                                                {row.estatus === 'registrado' ?
                                                                    <Chip sx={{ color: 'white', fontWeight: 500 }} color="success" label="Registrado" />
                                                                :
                                                                    <Chip sx={{ color: 'white', fontWeight: 500 }} color="error" label="Vendido" />
                                                                }
                                                            </>
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        <Stack direction="row" spacing={1} sx={{ display: 'flex', justifySelf: 'center' }}>
                                                            <IconButton title="Editar" aria-label="edit" size="small" onClick={() => handleArticles(row.uuid)} >
                                                                <Edit fontSize="inherit" color="warning" />
                                                            </IconButton>
                                                            <IconButton title="Vista previa" aria-label="preview" size="small" onClick={() => navigate("/adminDetail", { state: { productId: row?.uuid } })} >
                                                                <Outbox fontSize="inherit" color="info" />
                                                            </IconButton>
                                                            <IconButton title="Eliminar" aria-label="delete" size="small" onClick={() => handleDeleteArticle(row?.uuid)} >
                                                                <Delete fontSize="inherit" color="error" />
                                                            </IconButton>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Box>
                    :
                        <Typography
                            variant="h2"
                            component="div"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                color: 'dimgray',
                                fontFamily: 'Barlow',
                                height: '70vh',
                                placeItems: 'center'
                            }}
                        >
                            Sin productos registrados
                        </Typography>
                    }
                </>
            }
            <Backdrop
                sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                open={loadingDelete}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <AddPhysicalState showOffCanvas={showPhysicalCanvas} handleCloseOffCanvas={handleClosePhysicalCanvas} />
            <AddArticle showOffCanvas={showArticleCanvas} data={selectedArticle} handleCloseOffCanvas={handleCloseArticleCanvas} />
            <SnackBarMessage severity={snackSeverity} message={snackMessage} open={snackOpen} hideDuration={1500} onClose={() => setSnackOpen(false)} />
        </Box>
    )
}

export default CommonAdminListPage;
